import React, { FC, useCallback, useEffect, useMemo, useState } from 'react';
import LogOnMountWithStandardEventProperties from '../log_on_mount_with_standard_event_properties/LogOnMountWithStandardEventProperties';
import { Button, Card, Col, Drawer, Layout, Popconfirm, Row, Table } from 'antd';
import MetersDetailDetailsPage from '../meters_detail_details_page/MetersDetailDetailsPage';
import SubnavBar from '../subnav_bar/SubnavBar';
import { Link } from 'react-router-dom';
import { getLinkWIthBackLinkParams } from '../../utils/HistoryUtils';
import AssetDowntimeStatus from '../assets_detail_page/AssetDowntimeStatus';
import AssetActiveWorkOrdersCard from '../asset_page_display/AssetActiveWorkOrdersCard';
import { MeterRowDisplay } from '../meter_row_display/MeterRowDisplay';
import AssetTile from '../asset_status_form/AssetTile';
import {
	getEntityById,
	nullSafeGet,
	nullSafeGetOrElse,
	onRowWithRangeSelection,
} from '../../utils/DataAccessUtils';
import AssetDetailsCard from '../asset_details_card/AssetDetailsCard';
import { TwoLineList } from '../two_line_list/TwoLineList';
import LocationCardDisplay from '../location_card_display/LocationCardDisplay';
import { WarrantyCardDisplay } from '../warranty_card_display/WarrantyCardDisplay';
import {
	getProtectedImageUriForBuyer,
	getProtectedImageUriForSupplier,
} from '../../utils/FileAccessUtils';
import WorkOrderRowDisplay from '../work_order_row_display/WorkOrderRowDisplay';
import { BUYER_ONLY_NO_STORE_ASSOCIATE } from '../roles/roles';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import {
	assetDowntimeGet,
	assetsRestCrudThunksForBuyer,
	assetsRestCrudThunksForSupplier,
	cancelScheduledAssetTransfer,
} from '../../thunks/assets_thunks';
import { getScheduledTransferInitialValues } from '../../utils/assetUtils';
import BulkTransferToLocationModal from '../supplier_assets_index_page/BulkTransferToLocationModal';
import BulkTransferToStockLocationModal from '../supplier_assets_index_page/BulkTransferToStockLocationModal';
import {
	warrantiesRestCrudThunksForBuyer,
	warrantiesRestCrudThunksForSupplier,
} from '../../thunks/warranties_thunks';
import QRCode from 'qrcode.react';
import AssetDetailPageHeader from '../asset_detail_page_header/AssetDetailPageHeader';
import AssetInvoice from '../asset_invoice/AssetInvoice';
import {
	getBuyerCompanySettingValue,
	isUserAllowedToAccess,
	PERMISSION_NAMES,
} from '../../utils/AuthUtils';

import FileUploader from '../file_uploader/FileUploader';

import { ROLE_TYPES } from '../../utils/DataConstants';
import AssetWorkOrderHistory from '../AssetWorkOrderHistory';
import AssetPurchasePrice from '../asset_purchase_price/AssetPurchasePrice';
import Ellipsis from 'ant-design-pro/lib/Ellipsis';
import DateTimeHover from '../date_time_component/DateTime';
import { ArrowRightOutlined, EditOutlined } from '@ant-design/icons';

const { Content } = Layout;

require('./AssetDetailPageDisplay.less');

const AssetDetailPageDisplay: FC<any> = ({
	//From Parent
	asset = {},
	isDrawer = false,
	hideDeletedDetails,

	//Mapped State to props
	history,
	warranty,
	companyConfig,
	currentUser,
	location,
	userType,

	//mapDispatchToProps
	getAssetDowntime,
	getWarranty,
	getAsset,
	updateAsset,
	cancelScheduledTransfer,
}): React.ReactElement => {
	const [meterDrawerVisible, setMeterDrawerVisible] = useState(false);
	const [meterId, setMeterId] = useState();
	const [downTimeHistory, setDownTimeHistory] = useState([]);
	const [showEditTransferModal, setShowEditTransferModal] = useState(false);

	const assetId = nullSafeGet('id', asset);

	const scheduledTransfer = nullSafeGet('nextScheduledTransfer', asset);
	const isLocationTransfer = !!nullSafeGet('nextScheduledTransfer.state.locationId', asset);
	const editTransferInitialValues = useMemo(
		() => getScheduledTransferInitialValues(asset),
		[asset]
	);

	const getAssetDetails = () => {
		if (assetId) {
			const warranty = nullSafeGet('warrantyIds.0', asset);
			getAssetDowntime({ assetId }, userType).then((data = []) => {
				setDownTimeHistory(data);
			});

			if (warranty) {
				getWarranty(warranty);
			}
		}
	};

	useEffect(() => {
		getAssetDetails();
	}, [assetId]);

	const handleMeterDrawerOpen = (id) => {
		setMeterDrawerVisible(true);
		setMeterId(id);
	};

	const handleMeterDrawerClose = () => {
		setMeterDrawerVisible(false);
		setMeterId(undefined);
	};

	const openDowntimeHistoryTab = () => {
		history.push(`/${userType}/assets/detail/${assetId}/downtimeHistory`);
	};

	const handleAssetStatusChangeSubmit = () => {
		getAsset(assetId).then(() => {
			getAssetDetails();
		});
	};

	let photoUris = [];
	if (asset.images) {
		photoUris = asset.images.map((locImg) => {
			const [imgFileId, imgFileName] = locImg.split('/');
			return userType === 'supplier'
				? getProtectedImageUriForSupplier(imgFileId, imgFileName, 1200, 800)
				: getProtectedImageUriForBuyer(imgFileId, imgFileName, 1200, 800);
		});
	}
	const workOrderColumns = [
		{
			title: 'Name',
			dataIndex: 'title',
			render: (text, record) => <WorkOrderRowDisplay workOrder={record} />,
		},
	];

	const onWorkOrderRow = (record) => ({
		onClick: () => history.push(`/${userType}/workOrders/detail/${record.id}`),
	});

	const onMeterRow = (record) => ({
		onClick: () => handleMeterDrawerOpen(record.id),
	});

	const newWorkOrderLink =
		(currentUser.roles &&
			currentUser.roles.some((role) => BUYER_ONLY_NO_STORE_ASSOCIATE.has(role))) ||
		userType === ROLE_TYPES.SUPPLIER
			? 'newWorkOrder'
			: 'requestService';

	const allowArea = useMemo(
		() =>
			getBuyerCompanySettingValue(userType)(
				'assetConfig.allowAreaAssociationWithAssets',
				companyConfig,
				currentUser,
				false
			),
		[companyConfig, currentUser, userType]
	);

	const removeAssetNumberToQRCodeAssociation = useMemo(
		() =>
			getBuyerCompanySettingValue(userType)(
				'assetConfig.removeAssetNumberToQRCodeAssociation',
				companyConfig,
				currentUser,
				false
			),
		[companyConfig, currentUser, userType]
	);

	const canShowDowntimeDetailsAndLink = useMemo(
		() => (hideDeletedDetails ? !asset.isDeleted : true),
		[asset.isDeleted, hideDeletedDetails]
	);

	const handleFileAttachmentUploadChange = useCallback(
		(attachments) => {
			const updatedAsset = {
				...asset,
				attachments,
			};
			updateAsset(updatedAsset);
		},
		[asset, updateAsset]
	);

	const canShowAttachments = useMemo(
		() =>
			isUserAllowedToAccess(userType)(
				PERMISSION_NAMES.SHOW_ASSET_INTERNAL_ATTACHMENTS,
				companyConfig,
				nullSafeGet('roles', currentUser)
			),
		[companyConfig, currentUser, userType]
	);

	const canModifyAttachments = useMemo(
		() =>
			isUserAllowedToAccess(userType)(
				PERMISSION_NAMES.MODIFY_ASSET_INTERNAL_ATTACHMENTS,
				companyConfig,
				nullSafeGet('roles', currentUser)
			),
		[companyConfig, currentUser, userType]
	);

	return (
		<Content
			className="assetDetailPageDisplay"
			style={{
				padding: '0 0.5em',
			}}
			key={assetId}
		>
			<LogOnMountWithStandardEventProperties eventType="visited buyer asset detail page" />

			<Drawer
				width={1000}
				placement="right"
				closable={true}
				onClose={handleMeterDrawerClose}
				visible={meterDrawerVisible}
			>
				<MetersDetailDetailsPage id={meterId} />
			</Drawer>
			{isDrawer ? (
				<AssetDetailPageHeader
					asset={asset}
					photoUris={photoUris}
					userType={userType}
					hideLinkButton={!canShowDowntimeDetailsAndLink}
				/>
			) : null}
			{isDrawer ? null : (
				<Row style={{ margin: '0.5em -8px' }} gutter={16}>
					<Col span={24}>
						<SubnavBar
							left={null}
							right={
								<div className="mb-2 flex flex-row items-center justify-end">
									<Link
										to={getLinkWIthBackLinkParams(
											location,
											'Back to Asset Detail',
											`/${userType}/assets/${assetId}/${newWorkOrderLink}`
										)}
									>
										<Button type="primary" size="large">
											Request Service
										</Button>
									</Link>
								</div>
							}
						/>
					</Col>
				</Row>
			)}
			<Row gutter={16}>
				<Col lg={24} xl={16}>
					{scheduledTransfer ? (
						<div className="rowSpacing">
							<div className="flex flex-col gap-4 rounded border border-solid border-[#8DD6EA] bg-[#EAFAFE] p-4">
								<div className="flex flex-col gap-3">
									<span className="h5regular text-character-primary">
										This asset is scheduled for transfer
									</span>
									<div className="mr-4 flex flex-shrink flex-row items-center gap-2">
										<span className="rowGrayChip">
											<i className="icons8-font icons8-location-marker mr-1" />
											<span>{nullSafeGet('location.name', asset)}</span>
										</span>
										{asset.nextScheduledTransfer ? (
											<div className="flex flex-shrink flex-row items-center gap-2">
												<ArrowRightOutlined />
												<span className="rowGrayChip">
													<i
														className={`icons8-font ${
															nullSafeGet('nextScheduledTransfer.state.location.name', asset)
																? 'icons8-location-marker'
																: 'icons8-warehouse-3'
														} mr-1`}
													/>
													<span>
														{nullSafeGetOrElse(
															'nextScheduledTransfer.state.location.name',
															asset,
															nullSafeGet('nextScheduledTransfer.state.stockLocation.name', asset)
														)}
													</span>
												</span>
												<span className="bodyregular text-[#6C7280] ">
													Transfer Scheduled:{' '}
													<DateTimeHover
														showDate
														showTime
														timestamp={nullSafeGet('nextScheduledTransfer.triggerAt', asset)}
														timeZone={nullSafeGetOrElse(
															'nextScheduledTransfer.state.location.timeZoneId',
															asset,
															nullSafeGet(
																'nextScheduledTransfer.state.stockLocation.timeZoneId',
																asset
															)
														)}
													/>
												</span>
											</div>
										) : null}
									</div>
								</div>
								<div className="flex flex-row gap-4">
									<Button icon={<EditOutlined />} onClick={() => setShowEditTransferModal(true)}>
										Edit
									</Button>
									<Popconfirm
										title="Cancel this scheduled transfer?"
										onConfirm={() =>
											cancelScheduledTransfer({ assetIds: [assetId] }).then(() => getAsset(assetId))
										}
										okText="Cancel Transfer"
										cancelText="Keep"
										okButtonProps={{ danger: true }}
									>
										<Button>Cancel Transfer</Button>
									</Popconfirm>
								</div>
							</div>
						</div>
					) : null}
					{showEditTransferModal && scheduledTransfer && isLocationTransfer && (
						<BulkTransferToLocationModal
							assets={[asset]}
							transferId={scheduledTransfer.triggerAt}
							initialValues={editTransferInitialValues}
							currentLocationId={nullSafeGet('location.id', asset)}
							onCancel={() => setShowEditTransferModal(false)}
							onSuccess={() => {
								setShowEditTransferModal(false);
								getAsset(assetId);
							}}
						/>
					)}
					{showEditTransferModal && scheduledTransfer && !isLocationTransfer && (
						<BulkTransferToStockLocationModal
							assets={[asset]}
							transferId={scheduledTransfer.triggerAt}
							initialValues={editTransferInitialValues}
							currentStockLocationId={nullSafeGet('stockLocation.id', asset)}
							onCancel={() => setShowEditTransferModal(false)}
							onSuccess={() => {
								setShowEditTransferModal(false);
								getAsset(assetId);
							}}
						/>
					)}
					{asset.description && asset.description.length > 0 ? (
						<div className="rowSpacing">
							<Card bodyStyle={{ padding: 0 }}>
								<div className="materialCard__body">
									<div className="materialCard__primaryTitle">
										<div className="materialCard__title">{asset.description}</div>
									</div>

									<div
										style={{ marginBottom: 24 }}
										className="richTextWrapper"
										dangerouslySetInnerHTML={{ __html: asset.notes }}
									/>
								</div>
							</Card>
						</div>
					) : null}
					{canShowDowntimeDetailsAndLink ? (
						<div className="rowSpacing">
							<AssetDowntimeStatus
								showDetailsButton
								downtimeHistory={downTimeHistory || []}
								onSeeDetail={openDowntimeHistoryTab}
							/>
						</div>
					) : null}
					<div className="rowSpacing">
						<AssetActiveWorkOrdersCard assetId={assetId} />
					</div>
					<div className="rowSpacing">
						<AssetWorkOrderHistory assetId={assetId} />
					</div>
					<div className="rowSpacing">
						<Card title="Meters">
							<Table
								dataSource={asset.meters}
								showHeader={false}
								pagination={false}
								onRow={onRowWithRangeSelection(onMeterRow)}
								columns={[
									{
										title: 'ID',
										dataIndex: 'id',
										render: (text, record) => <MeterRowDisplay meter={record} />,
									},
								]}
							/>
						</Card>
					</div>
				</Col>
				<Col lg={24} xl={8}>
					{canShowDowntimeDetailsAndLink ? (
						<div className="rowSpacing">
							<AssetTile
								hideEditButton={isDrawer}
								downTimeHistory={downTimeHistory}
								userType={userType}
								asset={asset}
								onSuccess={handleAssetStatusChangeSubmit}
							/>
						</div>
					) : null}
					<div className="rowSpacing">
						<Card title="Asset Label" className="materialCard" bodyStyle={{ padding: 0 }}>
							<div className="materialCard__body" style={{ display: 'flex' }}>
								<div style={{ marginRight: 40 }}>
									{removeAssetNumberToQRCodeAssociation ? (
										asset.isUserAssignedUUID && asset.assetUUID && asset.assetUUID.length > 0 ? (
											<QRCode size={96} value={asset.assetUUID} />
										) : (
											<span>QR code is not assigned</span>
										)
									) : asset.assetUUID && asset.assetUUID.length > 0 ? (
										<QRCode size={96} value={asset.assetUUID} />
									) : null}
								</div>
								{!removeAssetNumberToQRCodeAssociation &&
								nullSafeGetOrElse('assetNumber', asset, '').trim() ? (
									<div>
										<div style={{ marginBottom: 8 }}>
											<h3>
												<Ellipsis fullWidthRecognition={true} lines={1} tooltip>
													{asset.assetNumber}
												</Ellipsis>
											</h3>
										</div>
										<div className="twoLineList__secondLine">Asset Number</div>
									</div>
								) : null}
							</div>
						</Card>
					</div>
					<div className="rowSpacing">
						<AssetInvoice asset={asset} />
					</div>
					<div className="rowSpacing">
						<AssetPurchasePrice asset={asset} />
					</div>
					{canShowAttachments || canModifyAttachments ? (
						<div className="rowSpacing">
							<Card title="Asset Attachments">
								<FileUploader
									roleType={userType}
									defaultFileList={asset.attachments || []}
									handleUploadSuccess={handleFileAttachmentUploadChange}
									uploaderType={canModifyAttachments ? 'dragger' : 'readOnly'}
								/>
							</Card>
						</div>
					) : null}
					<AssetDetailsCard asset={asset} />
					{nullSafeGetOrElse('assetModel.specs', asset, []).length > 0 ? (
						<div className="rowSpacing">
							<Card title="Asset Model Specs" className="materialCard" bodyStyle={{ padding: 0 }}>
								<div className="materialCard__body">
									<TwoLineList
										listItems={nullSafeGet('assetModel.specs', asset)}
										lineOneRender={(record) => record.value || '--'}
										lineTwoRender={(record) => record.key}
									/>
								</div>
							</Card>
						</div>
					) : null}
					{allowArea && nullSafeGet('area', asset) ? (
						<div className="rowSpacing">
							<Card title="Area">
								{nullSafeGetOrElse('area.hierarchyName', asset, nullSafeGet('area.name', asset))}
							</Card>
						</div>
					) : null}
					{nullSafeGet('location', asset) ? (
						<div className="rowSpacing">
							<LocationCardDisplay location={asset.location} />
						</div>
					) : null}
					{asset.warrantyId ? (
						<div className="rowSpacing">
							<WarrantyCardDisplay warranty={warranty} />
						</div>
					) : null}
				</Col>
			</Row>
		</Content>
	);
};

const mapStateToProps = (state, ownProps) => ({
	warrantiesFetching: state.warranties.fetching,
	warranty: nullSafeGet('warrantyIds.0', getEntityById(ownProps.match.params.id, state.assets))
		? state.warranties.detail
		: undefined,
	currentUser: state.session.currentUser,
	match: ownProps.match,
	history: ownProps.history,
	companyConfig: state.company_config.detail,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	getWarranty: (id) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? warrantiesRestCrudThunksForSupplier.readOne(id)
				: warrantiesRestCrudThunksForBuyer.readOne(id)
		),
	getAssetDowntime: (params, userType) => dispatch(assetDowntimeGet(userType)(params)),
	getAsset: (id) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? assetsRestCrudThunksForSupplier.readOne(id)
				: assetsRestCrudThunksForBuyer.readOne(id)
		),
	updateAsset: (entity) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? assetsRestCrudThunksForSupplier.update(entity)
				: assetsRestCrudThunksForBuyer.update(entity)
		),
	cancelScheduledTransfer: (data) =>
		dispatch(cancelScheduledAssetTransfer(ROLE_TYPES.SUPPLIER)(data)),
});

const ComponentWithoutUserType = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(AssetDetailPageDisplay)
);

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(ComponentWithoutUserType);
